<template>
  <div class="box" v-if="experienceShow">
    <div class="content">
      <div class="close" @click="$emit('experienceClick')">
        <img :src="close" alt="" />
      </div>
      <div class="header">
        <div class="header_border"></div>
        <div class="header_title">微信扫码立即体验</div>
        <div class="header_border"></div>
      </div>

      <div class="download_list">
        <div class="download_item" v-for="item in downloadList" :key="item.id">
          <div class="download_item_img">
            <img :src="item.img" alt="" />
          </div>
          <div class="download_item_flex">
            <div class="download_item_logo">
              <img :src="item.logo" alt="" />
            </div>
            <div class="download_item_bottom">
              <div>
                {{ item.title }}<span>（{{ item.remark }}）</span>
              </div>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import close from "../../../assets/close.png";
import img1 from "../../../assets/downloadApp/img1.jpg";
import img2 from "../../../assets/downloadApp/img2.png";
import img3 from "../../../assets/downloadApp/img3.png";
import logo1 from "../../../assets/downloadApp/logo1.png";
import logo2 from "../../../assets/downloadApp/logo2.png";

export default {
  props: ["experienceShow"],
  setup() {
    return reactive({
      close: close,
      downloadList: [
        {
          id: 1,
          title: "数字家园",
          text: "微信小程序",
          logo: logo1,
          img: img1,
          remark: "业主端",
        },
        {
          id: 2,
          title: "数字家园",
          text: "Android APP 下载",
          logo: logo2,
          img: img3,
          remark: "业主端",
        },
        {
          id: 3,
          title: "数字家园管理端",
          text: "Android APP 下载",
          logo: logo2,
          img: img2,
          remark: "数字家园管理端",
        },
      ],
    });
  },
};
</script>

<style scoped>
.box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.content {
  padding: 50px 40px;
  width: 865px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  background-image: url(../../../assets/experience.png);
  background-size: 100% 200px;
  background-repeat: no-repeat;
  text-align: center;
}
.close {
  position: absolute;
  top: 3%;
  right: 3%;
  cursor: pointer;
}
.close img {
  width: 36px;
}
/*  */
.header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_border {
  width: 120px;
  opacity: 1;
  border-top: 1px solid #666666;
}
.header_title {
  margin: 0 14px;
  font-size: 20px;
  color: #666666;
}
.download_list {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 40px;
}
.download_item_img {
  border: 1px dashed rgba(0, 0, 0, 0.7);
}
.download_item_img img {
  width: 192px;
  padding: 14px;
}
.download_item_flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.download_item_logo img {
  width: 32px;
  margin-right: 10px;
}
.download_item_bottom {
  text-align: left;
}
.download_item_bottom div:nth-of-type(1) {
  font-size: 22px;
  color: #333333;
}
.download_item_bottom div:nth-of-type(2) {
  margin-top: 8px;
  font-size: 12px;
  color: #3d3d3d;
}
.download_item_bottom div span {
  font-size: 16px;
}
</style>
